// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".load-spinner{background:hsla(0,0%,100%,.5);bottom:0;left:0;margin:auto;position:absolute;right:0;top:0;z-index:1}@media (min-width:767px){.load-spinner{bottom:0;top:0}}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.load-spinner .spinner{bottom:0;height:2rem;left:0;margin:auto;position:absolute;right:0;top:0;width:2rem}.load-spinner svg{animation:spin .7s linear infinite;height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
